/** @jsx jsx */
import { jsx, Button, Flex } from 'theme-ui'
import { bool, node, oneOf, string } from 'prop-types'
import { buttonStyles } from './Styled'

// use this for all primary and secondary buttons
const CfnButton = ({
  children,
  color,
  leftIcon,
  rightIcon,
  size,
  buttonStyle,
  fontColor,
  ...props
}) => {
  const getDimensions = size => {
    if (size === 'small') return '50px'
    if (size === 'medium') return '60px'
    if (size === 'large') return '75px'
  }

  const getStyle = style => buttonStyles[buttonStyle][color][style]

  return (
    <Button
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: getDimensions,
        color: fontColor ? fontColor : getStyle('color'),
        bg: props.disabled ? getStyle('bgDisabled') : getStyle('bg'),
        '&:hover': {
          bg: props.disabled ? getStyle('bgDisabled') : getStyle('bgHover'),
          borderColor: getStyle('borderColorHover'),
          cursor: 'pointer',
        },
        '&:focus': {
          outline: 'none',
        },
        fontSize: size === 'small' ? 2 : 4,
        borderColor: getStyle('borderColor'),
        maxHeight: size === 'small' ? 50 : 'inherit',
      }}
      variant={buttonStyle}
      {...props}
    >
      {leftIcon && <Flex sx={{ pr: 4 }}>{leftIcon}</Flex>}
      {children}
      {rightIcon && <Flex sx={{ pl: 4 }}>{rightIcon}</Flex>}
    </Button>
  )
}

CfnButton.propTypes = {
  buttonStyle: oneOf(['primary', 'secondary', 'tertiary']).isRequired,
  children: node,
  color: oneOf(['forest', 'sky', 'skyLight', 'citron', 'paleSilver'])
    .isRequired,
  disabled: bool,
  leftIcon: node,
  rightIcon: node,
  fontColor: string,
  size: oneOf(['small', 'medium', 'large']).isRequired,
}

CfnButton.defaultProps = {
  buttonStyle: 'primary',
  color: 'forest',
  size: 'medium',
}

export default CfnButton
